<template>
<div>
<el-menu :default-active="activeIndex" class="el-menu-demo" mode="horizontal" @select="handleSelect">
  <el-menu-item index="1">友邦客户管理</el-menu-item>
  <el-menu-item index="2">团单/个人客户管理</el-menu-item>
  </el-menu>
   <br>
<el-form :inline="true"  >
  
 
  <el-form-item label="客户姓名" >
    <el-input v-model="Name" placeholder="姓名" ></el-input>
  </el-form-item>
  <el-form-item label="身份证号"  >
    <el-input v-model="PaperValue" placeholder="身份证号"></el-input>
  </el-form-item>


   <router-link to="/TDAdd"  style="float：right"><el-button type="success" style="margin-right:0px;">出签</el-button></router-link>
 
 <el-table 
    border
    height="400px"
    v-loading="loading"
    @row-click="dialog"
    :data="tableData.filter(data =>  data.Name.toLowerCase().indexOf(Name.toLowerCase())>=0  && data.PaperValue.toLowerCase().indexOf(PaperValue.toLowerCase())>=0&& data.CustomerID.toLowerCase().indexOf(CustomerID.toLowerCase())>=0)"
  >

     <el-table-column
      label="姓名"
      prop="Name">
    </el-table-column>
  
    <el-table-column
      label="手机"
      prop="Mobile">
    </el-table-column>
  <el-table-column
      label="证件号码"
      prop="PaperValue">
    </el-table-column>
 
    
  </el-table>
   <el-dialog title="详情" :close-on-click-modal="false" width="100%"  :close-on-press-escape="false" :show-close="false" :visible="dialogTableVisible" :fullscreen="true">
   <el-descriptions   :column="1"  style="width:100%"  border>
  <el-descriptions-item label="签证号码"><span class='b'>{{this.Huzhaohao}}
  &nbsp;&nbsp;&nbsp;&nbsp;<el-button type="danger" size="small" style="margin-right:0px;" v-show="ishuzhaoDisplay" @click="CancelHZ">注销签证</el-button> 
  </span></el-descriptions-item>
  <el-descriptions-item label="姓名"><span class='b'>{{this.name}}</span></el-descriptions-item>
  <el-descriptions-item label="性别" ><span class='b'>{{this.Sex}}</span></el-descriptions-item>
  <el-descriptions-item label="身份证" ><span class='b'>{{this.paperValue}}</span></el-descriptions-item>
  <el-descriptions-item label="手机号" ><span class='b'>{{this.Mobile}}&nbsp;&nbsp;&nbsp;&nbsp;<el-button type="danger" size="small" @click="message">查看收件箱记录</el-button></span></el-descriptions-item>
  <el-descriptions-item label="产品名称" ><span class='b'>{{this.PName}}</span></el-descriptions-item>
  <el-descriptions-item label="预约日期" ><span class='b'>{{this.YuYueRiQi}}
   &nbsp;<el-button type="danger" size="small" style="margin-right:0px;" v-show="isqueryDisplay" @click="query">{{isquery}}</el-button> 
  </span></el-descriptions-item>
  <el-descriptions-item label="体检日期" ><span class='b'>{{this.TiJianRiQi}}</span></el-descriptions-item>
    <el-descriptions-item label="备注" ><span class='b'>{{this.BeiZhu}}</span></el-descriptions-item>
      <el-descriptions-item label="追加备注" ><span class='b'><el-input
  type="textarea"
  :rows="2"
  placeholder="请输入内容"
  v-model="BeiZhuNew">
</el-input><el-button type="danger" size="small"  @click="AddBeiZhu">确定</el-button></span></el-descriptions-item>
   </el-descriptions>
 <div style="text-align:center;margin-bottom:10px;">
   <el-button type="primary" @click="dialogTableVisible = false">知道了</el-button>
</div>
</el-dialog>
    </el-form>



</div>
</template>

<script>
// import elTableInfiniteScroll from 'el-table-infinite-scroll';
import {restbase} from '../rest'
import {foowwLocalStorage} from '../rest'
import {restbase2} from '../rest'
import { jsonrepair } from 'jsonrepair';
export default {
  // directives: {
  //   'el-table-infinite-scroll': elTableInfiniteScroll
  // },
  data() {
    return {
      tableData: [],
      Name: '',
      PaperValue: '',
      CustomerID: '',
      loading: true,
      admin:[],
      formLabelWidth: '320px',
       dialogTableVisible:false,
       name:'',
       paperValue:'',
       vipLevel:'',
       BeiZhu:'',
       TiJianRiQi:'',
       YuYueRiQi:'',
       QianFaRiQi:'',
       PName:'',
       Mobile:'',
       Huzhaohao:'',
       customerID:'',
       Sex:'',
       isquery:'预约',
       isqueryDisplay:true,
       ishuzhaoDisplay:true,
       activeIndex: '2',  
        BeiZhuNew:''



       
    };
  },
   created(){
     //页面加载前执行
             
              this.admin=JSON.parse(foowwLocalStorage.get('admin'));
              if(this.admin==null){
                this.$alert('登录失效，请重新登录！', '错误', {
                         confirmButtonText: '确定',
                         callback: action => {
                         this.$router.push('/YBLogin');
                          }
                         });
                        
                }
           
        },
   mounted() 
   {
     //清除session
     sessionStorage.clear();
            
      this.fetchData();
            
   },
  methods: {
     handleSelect(key, keyPath) {
      if(key==1){
         this.$router.push('YBMember');
      }
      },
       //添加备注
              AddBeiZhu(){
              
          const loading = this.$loading({
          lock: true,
          text: '操作中，请稍等',
          spinner: 'el-icon-loading',
          background: 'rgba(0, 0, 0, 0.7)'
        });
              this.$http.post(restbase() + "asp/AddBeiZhu", {
                    visaNo:this.Huzhaohao,
                    BeiZhu:this.BeiZhuNew
                }).then((response) => {
                    var d = JSON.parse(response.body.d);
                    if (d.code == 0) {
                        this.$alert('备注追加成功', '追加备注', {
          confirmButtonText: '确定',
          callback: action => {
          loading.close();
          this.BeiZhu=this.BeiZhu+this.BeiZhuNew;
          this.BeiZhuNew='';
          }
        });
                        

                    } else {
                         this.$notify.error({
                            title: '错误',
                            message: d.status.description
                        });
                    }
                    
                }, (response) => {
                  
                }).catch((response) => {
                    
                });
          
            
             },
              message(){
              sessionStorage.setItem('Mobile',this.Mobile);
              this.$router.push('/YBMessage');
             },
      fetchData() {
                 this.tableData=[];
                 this.$http.post(restbase() + "asp/GetTBMember", {
                    name: this.admin.CnName
                }).then(response=>{
                   this.loading=false;
                    console.log(response.data.d);
                    //const d = JSON.parse('['+response.data.d.replace(/\r|\n/ig,'')+']');
                    //console.log(d);
                    let raw = response.data.d;
                   try {
                   // 先修复整个字符串（自动添加缺失的括号、转义控制字符）
                  let repaired = jsonrepair('[' + raw + ']');
                  const d = JSON.parse(repaired);
                    this.tdsdata = [];
                    d.forEach(e => {
                      this.tableData.push({huzhaohao:e.huzhaohao, Name:e.Name, Mobile:e.Mobile, PaperValue:e.PaperValue,PName:e.PName,QianFaRiQi:e.QianFaRiQi,YuYueRiQi:e.YuYueRiQi,
                      TiJianRiQi:e.TiJianRiQi,Sex:e.Sex,PaperType:e.PaperType,CustomerID:e.CustomerID,BeiZhu:e.BeiZhu,vipLevel:e.vipLevel});
                        
                    });
                    console.log(this.tableData);
                    } catch (e) {
                    console.error('jsonrepair 修复失败', e);
                    }
                }, response=>{
                    // eslint-disable-next-line  this.$root.admin.UserName
                    console.error(response);
                })
                .catch(response=>{
                    // eslint-disable-next-line
                    console.error(response);
                })
             },
              dialog(row) {
       var disease=JSON.parse(JSON.stringify(row));
       console.log(disease);
       this.Huzhaohao=disease.huzhaohao;
       this.name=disease.Name;
       this.paperValue=disease.PaperValue;
       this.Mobile=disease.Mobile;
       this.Sex=disease.Sex;
       this.customerID=disease.CustomerID;
       this.dialogTableVisible=true;
       this.BeiZhu=disease.BeiZhu;
       this.PName=disease.PName;
       this.YuYueRiQi=disease.YuYueRiQi;
       this.TiJianRiQi=disease.TiJianRiQi;
       this.vipLevel=disease.vipLevel;
       this.dialogTableVisible=true;
       console.log(disease.YuYueRiQi);
       if(this.YuYueRiQi!='' && this.TiJianRiQi==''){
       this.isquery='取消预约';
       this.isqueryDisplay=true;
       }else if(this.YuYueRiQi==''){
        this.isquery='预约';
         this.isqueryDisplay=true;
       }else if(this.TiJianRiQi!=''){
         this.isqueryDisplay=false;
       }
       if(this.YuYueRiQi!='')
       {
        this.ishuzhaoDisplay=false;
        }
       else{
        this.ishuzhaoDisplay=true;
       }
             },
            
            //预约
              query(){
              if(this.isquery=='预约')
              {
              let user={'PaperValue':this.paperValue,'phone':this.Mobile,'name':this.name,'product':this.PName};
              sessionStorage.setItem('user',JSON.stringify(user));
              this.$router.push('/YBquery');
              }else{
                
                this.CancelQuery();
              }

             },
            //取消预约
              CancelQuery(){
              this.$confirm('您确定要取消该预约吗?', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          center:true,
          customClass: 'confirm-p',
          type: 'warning'
        }).then(() => {
          const loading = this.$loading({
          lock: true,
          text: '操作中，请稍等',
          spinner: 'el-icon-loading',
          background: 'rgba(0, 0, 0, 0.7)'
        });
              this.$http.post(restbase2() + "booking/WSOnline.asmx/CancelAppointment", {
                    visaNo:this.Huzhaohao,
                    verifyCode: ''
                }).then((response) => {
                    var d = JSON.parse(response.body.d);
                    if (d.status.code == 0) {
                        this.$alert('预约已取消', '取消预约', {
          confirmButtonText: '确定',
          callback: action => {
          loading.close();
          this.dialogTableVisible=false;
                        this.fetchData();
          }
        });
                        

                    } else {
                         this.$notify.error({
                            title: '错误',
                            message: d.status.description
                        });
                    }
                    
                }, (response) => {
                  
                }).catch((response) => {
                    
                });
            })
            
             },
             CancelHZ(){
          this.$confirm('您确定要注销该签证吗?', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          center:true,
          customClass: 'confirm-p',
          type: 'warning'
        }).then(() => {
          const loading = this.$loading({
          lock: true,
          text: '操作中，请稍等',
          spinner: 'el-icon-loading',
          background: 'rgba(0, 0, 0, 0.7)'
        });
              this.$http.post(restbase() + "asp/SetGiveUpYB", {
                      HuZhaoHao:this.Huzhaohao,
                }).then((response) => {
                    var d = JSON.parse(response.body.d);
                    console.log(d);
                     loading.close();
                    if (d[0].code == 0) {
                        this.$alert('签证已注销', '签证注销', {
          confirmButtonText: '确定',
          callback: action => {
         
          this.dialogTableVisible=false;
                        this.fetchData();
          }
        });
                        

                    } else {
                         this.$notify.error({
                            title: '错误',
                            message: d.status.description
                        });
                    }
                    
                }, (response) => {
                  
                }).catch((response) => {
                    
                });
            })
             }

  }
}
</script>

<style scoped>
.el-table {
  width: 100%;
}
.el-dialog{
       display: flex;
       flex-direction: column;
       margin:0 !important;
       position:absolute;
       top:40%;
       left:50%;
       width: 90%;
       transform:translate(-50%,-50%);
       /*height:600px;*/
       max-height:calc(100% - 30px);
       max-width:calc(100% - 30px);
   }
   .confirm-p{
    width: 50px;
   }
</style>